import { render, staticRenderFns } from "./AdminSuperChallengeCenterSettings.vue?vue&type=template&id=28187e74&scoped=true&lang=pug&"
import script from "./AdminSuperChallengeCenterSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSuperChallengeCenterSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperChallengeCenterSettings.vue?vue&type=style&index=0&id=28187e74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28187e74",
  null
  
)

export default component.exports